import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  register: (username, password) => api.post('/auth/register', { username, password }),
  getMe: () => api.get('/auth/me'),
};

export const projectsAPI = {
  getAll: (category) => api.get('/projects', { params: { category } }),
  getOne: (id) => api.get(`/projects/${id}`),
  create: (formData) => api.post('/projects', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, formData) => api.put(`/projects/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete: (id) => api.delete(`/projects/${id}`),
  addImages: (id, formData) => api.post(`/projects/${id}/images`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  addVideo: (id, formData) => api.post(`/projects/${id}/video`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const contentAPI = {
  getPageContent: (pageName) => api.get(`/content/${pageName}`),
  updatePageContent: (pageName, content) => {
    const formData = new FormData();
    formData.append('content', content);
    return api.put(`/content/${pageName}`, formData);
  },
  uploadProfileImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/content/home/profile-image', formData);
  },
  uploadDemoreel: (file) => {
    const formData = new FormData();
    formData.append('video', file);
    return api.post('/content/home/demoreel', formData);
  },
  uploadCVImages: (files) => {
    const formData = new FormData();
    files.forEach(file => formData.append('images', file));
    return api.post('/content/cv/images', formData);
  },
  getSlideshowImages: () => api.get('/content/slideshow'),
  uploadSlideshowImages: (files) => {
    const formData = new FormData();
    files.forEach(file => formData.append('images', file));
    return api.post('/content/slideshow', formData);
  },
  deleteSlideshowImage: (index) => api.delete(`/content/slideshow/${index}`),
};

export const contactAPI = {
  send: (data) => api.post('/contact', data),
};

export default api;
